/* Dear eM v26.9 (Claude) — trình thiết kế, bước "Xem lại trước khi đặt hàng":
   - hàng 1: "← Sửa lại" + "Lưu lại & đóng" (lưu thiết kế vào sản phẩm, đóng khung, chưa thêm vào giỏ)
   - hàng 2: nút đặt hàng rộng bằng cả 2 nút trên
   - hiện giá (Tổng) ngay trên các nút; nếu khách đã áp voucher DEAREM10 thì hiện giá sau giảm.
   - v27.3 (26/10/2026): dưới giá sau giảm thêm dòng "Đã giảm X₫" (số tiền được giảm). */
(function () {
  'use strict';
  if (window.__emConfirmFoot || !/\/products\//.test(location.pathname)) return; window.__emConfirmFoot = 1;
  var P = 'html body .dmc-modal .dmc-panel--confirm .dmc-foot', Q = 'html body .dmp-modal .dmp-panel--confirm .dmp-foot';
  var BOX = P + ' .dmc-pricebox[data-dmc-price2],' + Q + ' .dmp-pricebox[data-dmp-price2]';
  function both(sfx) { return P + ' .dmc-pricebox[data-dmc-price2]' + sfx + ',' + Q + ' .dmp-pricebox[data-dmp-price2]' + sfx; }
  var css =
    '.em-cf-acts{display:grid!important;grid-template-columns:1fr 1fr!important;gap:8px!important;width:100%}' +
    '.em-cf-acts > *{width:100%!important;min-width:0!important;margin:0!important}' +
    '.em-cf-acts [data-dmc-back],.em-cf-acts [data-dmp-back]{order:1}' +
    '.em-cf-acts .em-cf-save{order:2;white-space:nowrap}' +
    '.em-cf-acts > :not(.em-cf-save):not([data-dmc-back]):not([data-dmp-back]){order:3;grid-column:1 / -1}' +
    P + ',' + Q + '{flex-direction:column!important;align-items:stretch!important}' +
    BOX + '{display:block!important;width:100%;margin:0 0 8px!important;padding:0!important;font-size:14px!important}' +
    both(' > *') + '{display:none!important}' +
    both(' > [class*="row--total"]') + '{display:flex!important;align-items:baseline;justify-content:space-between;gap:8px;padding:0!important;font-size:15px!important;font-weight:700}' +
    both(' > [class*="row--total"] span:last-child') + '{color:#7f63bd;font-size:18px}' +
    /* đã áp voucher: ẩn dòng Tổng giá gốc, thay bằng dòng Tổng giá sau giảm (giá gốc gạch ngang + nhãn -10%) */
    both('.em-cf-on > [class*="row--total"]') + '{display:none!important}' +
    both(' > .em-cf-disc') + '{display:flex!important;align-items:baseline;justify-content:space-between;gap:8px;margin:0;font-size:15px;font-weight:700;color:inherit}' +
    '.em-cf-disc__r{display:inline-flex;align-items:baseline;gap:6px;flex-wrap:nowrap;white-space:nowrap;justify-content:flex-end}' +
    '.em-cf-disc s{color:#9a93a3;font-weight:400;font-size:13px}' +
    '.em-cf-disc b{color:#7f63bd;font-size:18px;font-weight:700}' +
    '.em-cf-disc i{font-style:normal;font-size:11px;font-weight:700;color:#fff;background:#e0567a;border-radius:6px;padding:1px 5px;align-self:center}' +
    both(' > .em-cf-disc') + '{flex-wrap:wrap!important;row-gap:0}' +
    '.em-cf-disc small.em-cf-disc__sv{flex:0 0 100%;text-align:right;font-size:12px;font-weight:600;color:#d0456a;line-height:1.3}';
  var st = document.createElement('style'); st.id = 'em-confirm-foot-css'; st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  function num(t) { var d = (t || '').replace(/[^\d]/g, ''); return d ? parseInt(d, 10) : 0; }
  function fmt(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '₫'; }
  function voucherOn() { try { return localStorage.getItem('emVoucher') === 'DEAREM10'; } catch (e) { return false; } }

  function sync() {
    [].forEach.call(document.querySelectorAll('[data-dearem-customizer], .dmc-card'), function (r) {
      var inst = r.__dmc || r.__dmp; if (!inst || !inst.confirmPanel) return;
      var photo = !r.__dmc;
      var cp = inst.confirmPanel, acts = cp.querySelector(photo ? '.dmp-actions' : '.dmc-actions');
      if (!acts) return;
      acts.classList.add('em-cf-acts');
      if (!acts.querySelector('.em-cf-save')) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = (photo ? 'dmp-btn dmp-btn--ghost' : 'dmc-btn dmc-btn--ghost') + ' em-cf-save'; b.textContent = 'Lưu lại & đóng';
        b.addEventListener('click', function (e) {
          e.preventDefault();
          try { inst.hideConfirm(); } catch (x) {}
          try { inst.save(); } catch (x) {}
        });
        var back = acts.querySelector('[data-dmc-back],[data-dmp-back]');
        acts.insertBefore(b, back ? back.nextSibling : acts.firstChild);
      }
      /* giá sau voucher (nếu đã áp DEAREM10) */
      var pb = inst.priceBox2 || cp.querySelector('[data-dmc-price2],[data-dmp-price2]');
      if (!pb) return;
      var tot = pb.querySelector('[class*="row--total"] span:last-child');
      var dl = pb.querySelector('.em-cf-disc');
      if (voucherOn() && tot && num(tot.textContent)) {
        var v = num(tot.textContent), lbl = 'Tổng';
        var want = '<span>' + lbl + '</span><span class="em-cf-disc__r"><s>' + fmt(v) + '</s><b>' + fmt(v * 0.9) + '</b><i>-10%</i></span><small class="em-cf-disc__sv">Đã giảm ' + fmt(v - Math.round(v * 0.9)) + '</small>';
        if (!dl) { dl = document.createElement('div'); dl.className = 'em-cf-disc'; pb.appendChild(dl); }
        if (dl.getAttribute('data-k') !== want) { dl.innerHTML = want; dl.setAttribute('data-k', want); }
        if (!pb.classList.contains('em-cf-on')) pb.classList.add('em-cf-on');
      } else { if (dl) dl.remove(); if (pb.classList.contains('em-cf-on')) pb.classList.remove('em-cf-on'); }
    });
  }
  function start() {
    sync(); setInterval(sync, 500);
    /* bảng giá được vẽ lại khi đổi lựa chọn → đồng bộ ngay, không chớp giá cũ */
    if ('MutationObserver' in window) new MutationObserver(function () { sync(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
